module.exports = __webpack_public_path__ + "media/components/country-flag/static/az-c4b15e29fa3b8a4a7bc75172250946f8.svg";